<template>
    <div>
      <div class="card">
        <div class="card-header">
            <div class="col-md-12">
              <ol class="breadcrumb breadcrumb-card-header pull-left">
                  <li class="breadcrumb-item">
                    <a href="javascript:void(0);" @click="backParent">Product Template</a>
                  </li>
                  <li class="breadcrumb-item active">
                    <span v-if="template.template_no === null">New</span>
                    <span v-else>{{ template.template_no }}</span>
                  </li>
              </ol>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" v-model="template.name"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="date" class="col-sm-3 col-form-label text-left">Date</label>
                    <div class="col-sm-9">
                      <datetime v-model="template.template_date" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta"></datetime>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <label for="notes" class="col-sm-3 col-form-label text-left">Notes</label>
                    <div class="col-sm-9">
                      <textarea class="form-control" v-model="template.notes"></textarea>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="active" class="col-sm-3 col-form-label text-left"></label>
                    <div class="col-sm-9">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" id="active" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="template.active">
                        <label for="active" class="custom-control-label">Active?</label>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <table class="table table-sm table-item table-hover">
                        <thead>
                            <th>Product No.</th>
                            <th>Qty</th>
                            <th>Uom</th>
                            <th></th>
                        </thead>
                        <tbody>
                            <tr v-for="(d, index) in template.details" :key="d.id">
                              <td>
                                <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="d.product_no" @input="setProduct(index)"/>
                              </td>
                              <td><input type="text" class="form-control" v-model="d.qty"/></td>
                              <td>
                                  <select class="form-control" v-model="d.uom_id">
                                    <option v-for="uo in d.uomList" :key="uo.id">{{ uo.id }}</option>
                                  </select>
                              </td>
                              <td><button type="button" class="btn btn-sm btn-danger" @click="remove(index)" ><i class="fa fa-trash"></i></button></td>
                          </tr>
                          <tr>
                            <td colspan="8"><span style="color: blue; cursor: pointer;" @click="addNewLine">Add Line</span></td>
                          </tr>
                      </tbody>
                  </table>
              </div>
            </div>
        </div>
        <div class="card-footer">
          <button type="button" class="btn btn-sm btn-primary pull-right" v-if="template.id === null" @click="save">Save</button>
          <button type="button" class="btn btn-sm btn-primary pull-right" v-else @click="update">Update</button>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in template.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { getHeader, productUrl } from '../../config'

export default {
  name: 'ProductTemplateForm',
  props: ['template'],
  mounted () {
    this.$barcodeScanner.init(this.onBarcodeScanned)
  },
  destroyed () {
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy()
  },
  computed: {
    ...mapState({
      productList: state => state.products.productListAll,
      uomList: state => state.uom.uomList
    }),
    productselect: function () {
      var loop = []
      var array = this.productList
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: array[x].product_no + ' - ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    async save () {
      await axios.post(productUrl + '/template', this.template, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async update () {
      await axios.put(productUrl + '/template/' + this.template.id, this.template, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    remove: function (index) {
      var obj = this.template.details[index]
      if (obj.id !== undefined) {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(productUrl + '/template/detail' + obj.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                this.template.details.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
                this.$swal(
                  'Error',
                  error.response.data.message,
                  'error'
                )
              })
          }
        })
      } else {
        this.template.details.splice(index, 1)
      }
    },
    addNewLine: function () {
      var obj = {
        product_no: null,
        qty: 1,
        uom_id: null
      }
      this.template.details.push(obj)
    },
    setProduct: function (index) {
      var detail = this.template.details[index]
      var product = this.productList.find(d => d.product_no === detail.product_no)
      detail.uomList = product.uomList
      detail.uom_id = product.uom_id
    },
    backParent: function () {
      this.$emit('backClicked')
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
